import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'paginator-template',
    templateUrl: './paginator-template.html',

    styles: ['li.disabled { pointer-events: none; }']
})
export class PaginatorTemplate implements OnInit {
    @Output() GET_ACTIVE = new EventEmitter();

    constructor() { }

    ngOnInit() { }

    getActive() {
        this.GET_ACTIVE.emit();
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/shared/components/paginator-template/paginator-template.component.ts